import { CancelToken } from 'axios';
import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { InvitationDto } from '@api/models/invitation/InvitationDto';
import { InvitationState } from '@api/models/enums/InvitationState';
import { invitationPersonService, invitationService } from '@api/services/services';
import { selectIdentityRowsCount } from './identity';
import { invitationPersonListActions } from './invitationPersonList';

type State = BaseType<InvitationDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    name: '',
    state: InvitationState.Sent,
    validFrom: '',
    hasRiskForDownload: false,
  },
};

export const invitationSlice = baseSlice({
  name: 'invitation',
  initialState,
});

export const selectInvitationState = (state: RootState) => state.invitation.state;
export const selectInvitation = (state: RootState) => state.invitation.data;
export const invitationActions = invitationSlice.actions;

export const getInvitation = (invitationId: string, changeData: (data: InvitationDto) => Promise<InvitationDto>, cancelToken?: CancelToken) => (dispatch: AppDispatch) => {
  const config = cancelToken ? { cancelToken } : undefined;

  const handleGetData = async () => {
    const [dataResponse, personsResponse] = await Promise.all([
      invitationService.getById(invitationId, undefined, config),
      invitationPersonService.query({ invitationId, size: selectIdentityRowsCount(store.getState()) }, config),
    ]);
    dataResponse.data.persons = personsResponse.data.content;
    dispatch(invitationPersonListActions.success(personsResponse.data));
    return dataResponse;
  };

  getItem({
    dispatch,
    actions: invitationActions,
    getData: handleGetData,
    changeData,
  });
};
